import React from "react";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import StockAndDomesticTable from "@components/table/zenith/StockAndDomesticTable";
import StockAndDomesticModal from "@components/modal/StockAndDomesticModal";
import { useApprovalTabsContext } from "@components/layout/zenith/ApprovalTabs";
import { useAdministrativeApproval } from "@hooks/query/zenith/useAdministrativeApproval";

const StockAndDomesticIndex = () => {
  const { t } = useTranslation();
  const { setBreadcrumbs } = useApprovalTabsContext();
  const [searchParams, setSearchParams] = useSearchParams();
  const approvalId = searchParams.get("id") ?? "";
  const { data } = useAdministrativeApproval(approvalId);

  React.useEffect(() => {
    setBreadcrumbs([
      {
        label: t("approval.stock_and_domestic.title"),
      },
    ]);
  }, [t, setBreadcrumbs]);

  const handleClose = () => {
    searchParams.delete("id");
    setSearchParams();
  };

  return (
    <>
      <StockAndDomesticTable />
      {approvalId && data ? (
        <StockAndDomesticModal
          data={data}
          onClose={handleClose}
          actionButtons={
            <button className="btn-default" onClick={handleClose}>
              {t("common.close")}
            </button>
          }
        />
      ) : null}
    </>
  );
};

export default StockAndDomesticIndex;
